import m from "../../geodata/es2015/southKoreaLow";
window.am4geodata_southKoreaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/southKoreaLow.js
// module id = null
// module chunks = 